module.exports = __webpack_public_path__ + "static/media/logo_blue_white.8330622a.svg";